import { api } from "../data/client";

/**
 * "Show me the old version" (owner 2026-11-03): a STAFF person's own switch back to today's pages and frame, kept on the server
 * (users.legacy_view, /me → `legacy_view`). While it is on, every switchboard line answers "legacy" and the frame is the old one for
 * this person, whatever the release or the preview list says. Nobody else is affected. Like the preview flag, the browser's copy is
 * only a display hint (so a reload does not flash the new pages): it counts only while a sign-in token exists, and /me overwrites it.
 */
const KEY = "cy_legacy_view";
let memo: boolean | null = null;

const read = (): boolean => {
  try { return window.localStorage.getItem(KEY) === "1" && Boolean(window.localStorage.getItem("token")); } catch { return false; }
};

export const isLegacyView = (): boolean => (memo === null ? (memo = read()) : memo);

export const setLegacyView = (on: boolean): void => {
  memo = on;
  try { on ? window.localStorage.setItem(KEY, "1") : window.localStorage.removeItem(KEY); } catch { /* storage blocked: the memo rules */ }
};

/** The menu items: saves the choice on the server, then opens the start page in the chosen version. */
export const switchLegacyView = async (on: boolean, go: () => void = () => window.location.assign("/")): Promise<void> => {
  await api.put("/api/auth/me/legacy-view", { on });
  setLegacyView(on);
  go();
};
